const redux = require("redux");
const thunk = require("redux-thunk").default;

const defaultState = require("./types/AppState.js").Default;

const reducers = Object.assign({},
    require("~/events/reports/reportHandlers.js"),
    require("~/events/authentication/authenticationHandlers.js"),
    require("~/events/userLoad/userLoadHandlers.js"),
    require("~/events/questionChange/questionChangeHandlers.js"),
    require("~/events/routeChange/routeChangeHandlers.js"),
    require("~/events/alterEgoLoad/alterEgoLoadHandlers.js"),
    require("~/events/impersonation/impersonationHandlers.js"),
    require("~/events/auditLoad/auditLoadHandlers.js"),
    require("~/events/section/sectionHandlers.js"),
    require("~/events/auditSearch/auditSearchHandlers.js"),
    require("~/events/auditCreation/auditCreationHandlers.js"),
    require("~/events/walkThruLoad/walkThruLoadHandlers.js"),
    require("~/events/auditCompletion/auditCompletionHandlers.js"), 
    require("~/events/emailFetch/emailFetchHandlers.js")

);

function reduce(state, action) {
    state = state || defaultState;

    if (reducers.hasOwnProperty(action.type)) {
        var newState = reducers[action.type](state, action);

        return newState;
    }

    return state;
};

let createStore = redux.applyMiddleware(thunk)(redux.createStore);

const store = createStore(reduce);

module.exports = store;


// WEBPACK FOOTER //
// ./src/store.js